import React, { useEffect, useRef, useState } from "react";
import HeaderPrintForm from "../../PrintForm/HeaderPrintForm/HeaderPrintForm";
import {
  Button,
  Col,
  Descriptions,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
} from "antd";
import ReactToPrint from "react-to-print";
import { FORMAT_TIME } from "types/enums";
import {
  birthday2Age,
  convertIosStringToDateDayjs,
  formatDateToString,
  getAge,
  getDateStringLocale,
} from "helper/common";
import catalogService from "api/catalog";
import Notification from "../../notification/notification";
import Sign from "../../PrintForm/Sign/Sign";
import { useAppSelector } from "redux/hooks";
import { columns } from "./config";
import "./Analysis.scss";
import { analysisService } from "api";
import TableInputAdd from "components/common/TableInputAdd/TableInputAdd";
import moment from "moment";

const AnalysisModal = (props) => {
  const printRef = useRef<any>();
  const { closeModal } = props;
  const idAnalysis = useAppSelector((state) => state.reduxCommon.idPrintXn);
  const [data, setData] = useState([]);
  const [receiptDetails, setReceiptDetails] = useState(null);
  const [ketLuan, setKetLuan] = useState<any>(null);
  const [dataTable, setDataTable] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const onPrint = async () => {
    window.print();
  };
  const getPrintAnalysis = async () => {
    try {
      let response = await analysisService
        .getDataPrintXN(idAnalysis)
        .then((res) => {
          setReceiptDetails(res.data);
          const newData = res.data.nhomCDXNDtos;
          const dataTable = newData.map((item) => {
            return {
              key: item.tenNhomXetNghiem,
              tenXetNghiem: item.tenNhomXetNghiem,
              children: item.cdxnDtos.map((e, idx) => {
                if (e.tenXetNghiem == e.ketQua[0]?.tenChiSoXetNghiem) {
                  e.tenXetNghiem = "";
                }
                return {
                  key: `${e.tenXetNghiem}${e.id}${idx}`,
                  id: e.id,
                  tenXetNghiem: e.tenXetNghiem,
                  children: e.ketQua.map((i) => {
                    return {
                      ...i,
                      giaTri: checkValue(i.giaTri, i.giaTriBinhThuong),
                      key: `${i.tenChiSoXetNghiem}${i.id}${
                        Math.floor(Math.random() * (9999999 - 1 + 1)) + 1
                      }`,
                      tenXetNghiem: i.tenChiSoXetNghiem,
                    };
                  }),
                };
              }),
            };
          });
          setData(dataTable);
          setKetLuan(res.data.ketLuanDto?.chiTietKetLuans);
        });
    } catch (error) {}
  };
  const rowClassName = (record) => {
    const isNumber = /^\d+$/.test(record.key);
    return isNumber ? "number-row" : "";
  };

  const getTodayString = () => {
    // const today = moment().format();
    const day = moment().format("DD");
    const month = moment().format("MM");
    const year = moment().format("YYYY");
    const time = moment().format("HH:mm A");
    return `Ngày ${day} tháng ${month} năm ${year}`;
  };

  useEffect(() => {
    getPrintAnalysis();
  }, [idAnalysis]);

  const fields1 = [
    {
      label: "Họ và tên",
      value: receiptDetails?.hoTen?.toString()?.toUpperCase(),
    },
    {
      label: "Ngày sinh",
      value: formatDateToString(
        convertIosStringToDateDayjs(receiptDetails?.ngaySinh),
        FORMAT_TIME.dayFull
      ),
    },
    { label: "Tuổi", value: birthday2Age(receiptDetails?.ngaySinh) },
    { label: "Giới tính", value: receiptDetails?.gioiTinh == 1 ? "Nam" : "Nữ" },
    { label: "Điện thoại", value: receiptDetails?.dienThoai },
    { label: "Địa chỉ", value: receiptDetails?.diaChiTongHop },
    { label: "Số BHYT", value: receiptDetails?.maTheBhyt },
    // {label: "Nhân thân", value: receiptDetails?.thanNhan},
    // {
    //   label: "Chẩn đoán",
    //   value: receiptDetails?.ketLuanDto?.chiTietKetLuans?.map(item => {
    //     if (receiptDetails?.ketLuanDto?.chiTietKetLuans.length === 1) {
    //       return <div>{item.tenIcd}</div>;
    //     } else return <div>{item.tenIcd} - </div>;
    //   }),
    // },
  ];
  const fields2 = [
    {
      label: "Ngày lấy mẫu",
      value: formatDateToString(
        receiptDetails?.thoiGianTraKetQua,
        FORMAT_TIME.dateTime
      ),
    },
    { label: "Mã bệnh phẩm", value: receiptDetails?.maBenhPham },
    { label: "NV lấy mẫu", value: "" },

    { label: "Mã bệnh nhân", value: receiptDetails?.maBenhNhan },
    { label: "Buồng", value: receiptDetails?.buongSo },
    { label: "Giường", value: receiptDetails?.giuongSo },
  ];

  const expandAllRows = () => {
    const keys = [];
    const expandKeys = (data) => {
      data.forEach((item) => {
        keys.push(item.key);
        if (item.children) {
          expandKeys(item.children);
        }
      });
    };
    expandKeys(data);
    setExpandedRowKeys(keys);
  };

  const checkValue = (value, checkValue) => {
    const parsedValue = parseFloat(value);
    if (checkValue.indexOf("-") !== -1) {
      const mangGiaTri = checkValue.split("-");
      const giaTri1 = parseFloat(mangGiaTri[0]);
      const giaTri2 = parseFloat(mangGiaTri[1]);
      if (!isNaN(parsedValue)) {
        if (parsedValue < giaTri1) {
          return value + " (L)";
        } else if (parsedValue > giaTri2) {
          return value + " (H)";
        } else {
          return value;
        }
      } else {
        return value;
      }
    } else {
      return value;
    }
  };

  useEffect(() => {
    expandAllRows();
  }, [idAnalysis, data]);

  return (
    <div className="analysis-modal">
      <div ref={printRef}>
        <div style={{ padding: "0 50px" }}>
          <HeaderPrintForm />
          <div style={{ marginBottom: 12 }}>
            <Row justify={"center"}>
              <Typography.Title
                style={{
                  fontWeight: "700",
                  fontSize: 30,
                }}
              >
                PHIẾU KẾT QUẢ XÉT NGHIỆM
              </Typography.Title>
            </Row>
            <Row>
              <Col span={16}>
                <Descriptions
                  size="small"
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                >
                  {fields1 &&
                    fields1.map((e) => (
                      <Descriptions.Item
                        label={e.label}
                        labelStyle={{ width: "94px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {e?.value}
                      </Descriptions.Item>
                    ))}
                </Descriptions>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "94px" }}>
                    <Typography.Text style={{ fontSize: "15px" }}>
                      Chẩn đoán:
                    </Typography.Text>
                  </div>
                  <div>
                    {receiptDetails?.ketLuanDto?.chiTietKetLuans?.map(
                      (item) => (
                        <div style={{ fontWeight: "700" }}>
                          {item.maIcd}: {item.tenIcd}
                        </div>
                      )
                    )}
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ width: "94px" }}>
                    <Typography.Text
                      style={{ fontSize: "15px" }}
                    ></Typography.Text>
                  </div>
                  <div>
                    {receiptDetails?.ketLuanDto?.chiTietBenhPhuDtos?.map(
                      (item) => (
                        <div style={{ fontWeight: "700" }}>
                          {item.maIcd}: {item.tenIcd}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </Col>
              <Col span={8}>
                <Descriptions
                  size="small"
                  column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                >
                  {fields2 &&
                    fields2.map((e) => (
                      <Descriptions.Item
                        label={e.label}
                        labelStyle={{ width: "100px", color: "#000000" }}
                        contentStyle={{
                          fontWeight: "600",
                        }}
                      >
                        {e?.value}
                      </Descriptions.Item>
                    ))}
                </Descriptions>
                {/* <Row>
                  <QRCode value={receiptDetails?.idBenhNhan} size={120} />
                </Row> */}
              </Col>
            </Row>
          </div>

          <div className="content2">
            <TableInputAdd
              rowClassName={rowClassName}
              data={data}
              column={columns}
              className="table-result-analysis-custom"
              style={{ border: "1px solid #000000", borderBottom: "none" }}
              setData={setData}
              pagination={false}
              defaultExpandAllRows={true}
              expandedRowKeys={expandedRowKeys}
              expandable={{
                expandIcon: () => null,
              }}
            ></TableInputAdd>
          </div>
          {/* <Sign
            name="Trưởng khoa xét nghiệm"
            nguoiThucHien={receiptDetails?.tenDieuDuong}
          /> */}
          <Row style={{ marginTop: "10px", paddingBottom: "20px" }}>
            <Row justify={"end"}>
              <Typography.Text
                className="date-sign"
                style={{ marginRight: "50px" }}
              >
                {getDateStringLocale(
                  receiptDetails?.thoiGianTraKetQua ?? moment().format()
                )}
              </Typography.Text>
            </Row>
            <Row justify={"end"}>
              <Col>
                <Space direction="vertical" size={64}>
                  <Row>
                    <Row justify={"center"}>
                      <Typography.Text strong>
                        Trưởng khoa xét nghiệm
                      </Typography.Text>
                    </Row>
                    <Row justify={"center"}>
                      <Typography.Text type="secondary">
                        (Ký và ghi rõ họ tên)
                      </Typography.Text>
                    </Row>
                  </Row>
                  <Row justify={"center"}>
                    <Typography.Text strong>
                      {receiptDetails?.truongKhoaXetNghiem
                        ? `Ths. ${receiptDetails?.truongKhoaXetNghiem}`
                        : localStorage.getItem("fullName")}
                    </Typography.Text>
                  </Row>
                </Space>
              </Col>
            </Row>
          </Row>
        </div>
      </div>
      <Row justify={"end"} className="footer">
        <Space direction="horizontal">
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="analysis-modal"
            onAfterPrint={closeModal}
          />
        </Space>
      </Row>
    </div>
  );
};

export default AnalysisModal;
